var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.583,
    height: 27.008,
    viewBox: "0 0 38.583 27.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#33233d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.25 -4.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.9,31.258H6.185A4.883,4.883,0,0,1,1.25,26.467V9.042A4.883,4.883,0,0,1,6.185,4.25H34.9a4.883,4.883,0,0,1,4.935,4.792V26.467A4.883,4.883,0,0,1,34.9,31.258ZM6.185,6.864A2.211,2.211,0,0,0,3.942,9.042V26.467a2.211,2.211,0,0,0,2.243,2.178H34.9a2.211,2.211,0,0,0,2.243-2.178V9.042A2.211,2.211,0,0,0,34.9,6.864Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.532,19a5.8,5.8,0,0,1-2.961-.813L1.9,8.806A1.38,1.38,0,0,1,1.42,7a1.323,1.323,0,0,1,1.795-.47L18.9,15.892a3.014,3.014,0,0,0,3.158,0L37.741,6.529A1.323,1.323,0,0,1,39.536,7a1.38,1.38,0,0,1-.485,1.808L23.493,18.188A5.8,5.8,0,0,1,20.532,19Z",
    transform: "translate(0.01 1.698)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.df77e823255afbca191a10151f63169f.svg";
export { ForwardRef as ReactComponent };